import React, { useEffect, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import DataNotFound from '../../../../components/dataNotFound';
import PageLoader from '../../../../../component/PageLoader';
import AccountListTable from '../components/accountListTable';
import { useSelector } from 'react-redux';
import { getParentAccounts } from '../../../../../services/settings/accounting';
import CreateParentAccount from '../components/createParentAccount';
import DeleteParentAccountModal from '../components/deleteParentAccountModal';
import ParentAccountDetail from './parentAccountDetails';
import { hasPermission } from '../../../../../utils/controller';

export default function ParentAccounts({ activeTab }) {
	const [isOpenAccountModal, setIsOpenAccountsModal] = useState(false);
	const [isOpenDeleteAccountModal, setIsOpenDeleteAccountModal] = useState(false);
	const [loader, setLoader] = useState(false);
	const [list, setList] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [sortDirection, setSortDirection] = useState({ id: 'asc' });
	const [parentAccountId, setParentAccountId] = useState(null);
	const [type, setType] = useState('parent-account-list');
	const [params, setParams] = useState({
		page: 1,
		pageSize: 1000,
		order_by: 'created_at',
		sort_by: 'desc',
	});

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });

		setParams((prev) => ({
			...prev,
			order_by: param.order_by,
			sort_by: newDirection,
		}));
	};

	const onRowClick = (id) => {
		if (id && hasPermission('accounting.accounts.view', user?.role?.role_permissions)) {
			setParentAccountId(id);
			setType('parent-account-details');
		}
	};

	const getParentAccountsList = async () => {
		try {
			setLoader(true);
			const { accounts } = await getParentAccounts(params);
			if (accounts.length > 0) {
				const data = mappedTableData(accounts);
				setList(data);
			} else {
				setList([]);
			}
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.account_id,
				parent_account_name: ele.account_name || 'N/A',
				sub_account_count: ele?.sub_account_count || '0',
				status: ele?.status,
				description: ele?.description || '',
			};
		});
	}

	useEffect(() => {
		getParentAccountsList();
	}, [params]);

	const columns = [
		{ key: 'parent_account_name', label: 'PARENT ACCOUNT NAME' },
		{ key: 'sub_account_count', label: 'INCLUDED ACCOUNTS' },
		{ key: 'status', label: 'STATUS' },
		{ key: 'description', label: 'DESCRIPTION' },
		{ key: 'action', label: 'ACTIONS' },
	];

	return (
		<div>
			{type === 'parent-account-list' ? (
				<div>
					<div
						className="d-flex justify-content-between align-items-center sticky-top z-3 p-4"
						style={{ backgroundColor: '#EDEDF7' }}
					>
						<div>
							<div className="fs-3 fw-bold text-black">{activeTab}</div>
							<div
								className="fs-5 fw-light text-gray"
								style={{ color: '#718096' }}
							>
								{
									'Manage and organize parent accounts used for account grouping and financial hierarchy.'
								}
							</div>
						</div>
						<div className="d-flex gap-4 align-items-center">
							<Button
								type="button"
								button={'New Accounts'}
								disabled={false}
								className="btn btn-primary mt-0 px-3 fs-5 fw-light"
								add
								onClick={() => {
									setIsOpenAccountsModal(true);
									setParentAccountId(null);
								}}
							/>
						</div>
					</div>
					{loader ? (
						<PageLoader />
					) : list.length > 0 ? (
						<div className="productTable-body pt-4">
							<AccountListTable
								columns={columns}
								accountType={'parent-accounts'}
								row={list}
								sortDataList={sortDataList}
								onRowClick={onRowClick}
								setAccountId={setParentAccountId}
								sortDirection={sortDirection}
								setIsOpenAccountsModal={setIsOpenAccountsModal}
								setIsOpenDeactivateConfirmAccountModal={setIsOpenDeleteAccountModal}
							/>
						</div>
					) : (
						<DataNotFound
							title={'No parent accounts added yet!'}
							subtitle={'Manage and organize parent accounts to structure '}
							content={'related financial accounts efficiently.'}
							descriptionTitle={''}
							descriptionSubTitle={''}
							descriptionContent={''}
							buttonText={'Add New Account'}
							disabled={false}
							onClick={() => setIsOpenAccountsModal(true)}
						/>
					)}
				</div>
			) : type === 'parent-account-details' ? (
				<ParentAccountDetail
					parentAccountId={parentAccountId}
					type={type}
					setType={setType}
					setParentAccountId={setParentAccountId}
				/>
			) : (
				<></>
			)}
			{isOpenAccountModal && (
				<CreateParentAccount
					isOpenModal={isOpenAccountModal}
					setIsOpenModal={setIsOpenAccountsModal}
					id={parentAccountId}
					getList={getParentAccountsList}
				/>
			)}
			{isOpenDeleteAccountModal && (
				<DeleteParentAccountModal
					isOpenModal={isOpenDeleteAccountModal}
					setIsOpenModal={setIsOpenDeleteAccountModal}
					parentAccountId={parentAccountId}
					getList={getParentAccountsList}
				/>
			)}
		</div>
	);
}
